import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { addTime } from '../../../api';

import { OPTIONS_HORARIOS } from '../../../../../constants/configuracao-horarios';

import Colors from '../../../../../config/Colors';
import { Button } from '../../../../../components-reactjs/Button';
import { Creators as toastActions } from '../../../../../store/ducks/toast';
import { Select } from '../../../../../components-reactjs/Select';

import {
    Container,
    Header,
    HeaderTitle,
    SelectContent,
    DropdownSection,
    DropdownTitle,
    Footer
} from './styles';

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...toastActions }, dispatch);

const customStyles = {
    content: {
        minHeight: 280,
        minWidth: 420,
        padding: 0,
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 8,
        overflow: 'visible'
    },
    overlay: {
        zIndex: 10,
        backgroundColor: Colors.darkerTransparent
    }
};

export const ModalAddTime = connect(
    null,
    mapDispatchToProps
)(({
    useValues = [],
    selectedDay,
    useModalValues = [],
    idTipoEntregaRetirada,
    addToast
}) => {
    const closeAddTimeModal = () => setShouldModalUpen(false);
    const [weekTimeStates, setWeekTimeStates] = useValues;
    const [shouldModalOpen, setShouldModalUpen] = useModalValues;
    const [optionStart, setOptionStart] = useState(OPTIONS_HORARIOS[0]);
    const [optionEnd, setOptionEnd] = useState(OPTIONS_HORARIOS[0]);

    const onChangeStart = (optionSelected) => {
        setOptionStart(optionSelected);
    };

    const onChangeEnd = (optionSelected) => {
        setOptionEnd(optionSelected);
    };

    const sortHorarios = (a, b) => {
        if (Number(a.horaFim.substr(0, 2)) < Number(b.horaFim.substr(0, 2))) {
            return -1;
        }
        if (Number(a.horaFim.substr(0, 2)) > Number(b.horaFim.substr(0, 2))) {
            return 1;
        }
        return 0;
    };

    const timeToMinutes = (time) => {
        const [hours, minutes] = time.substr(0, 5).split(':').map(Number);
        return hours * 60 + minutes;
    };

    const addTimeToday = async () => {
        if (!optionStart || !optionEnd) {
            return;
        }

        const start = timeToMinutes(optionStart.value);
        const end = timeToMinutes(optionEnd.value);

        if (end <= start) {
            return addToast({
                text: 'O horário de término tem que ser maior que o inicial',
                more: 'OK',
                theme: 'error'
            });
        }

        const horarios = {
            horaInicio: optionStart.value,
            horaFim: optionEnd.value
        };

        try {
            const response = await addTime({
                idTipoEntregaRetirada,
                tpDiaSemana: selectedDay.tpDiaSemana,
                horarios
            });

            if (response.status === 400) {
                throw response.data.errorMessage;
            }

            horarios.idHorarioEntregaRetirada =
                response.data.idHorarioEntregaRetirada;
            selectedDay.horarios.push(horarios);
            selectedDay.horarios.sort(sortHorarios);

            const indexOfDay = weekTimeStates.findIndex(
                (day) => day.tpDiaSemana === selectedDay.tpDiaSemana
            );

            const newState = [...weekTimeStates];

            newState[indexOfDay] = selectedDay;

            setWeekTimeStates(newState);

            addToast({
                text: 'Horário adicionado',
                more: 'OK',
                theme: 'success'
            });
            closeAddTimeModal();
        } catch (error) {
            addToast({
                text: error,
                more: 'OK',
                theme: 'error'
            });
        }
    };

    let node;

    useEffect(() => {
        node = document.getElementById('add-time-modal');
    });
    return (
        <Modal
            id={'add-time-modal'}
            ariaHideApp={false}
            isOpen={shouldModalOpen}
            style={customStyles}
            onRequestClose={closeAddTimeModal}
            bodyOpenClassName={'ReactModal_opened'}
            contentLabel="Example Modal"
        >
            <Container className="modal-addtime-content">
                <Header>
                    <HeaderTitle>Selecione a faixa de horário</HeaderTitle>
                </Header>
                <SelectContent className="select-content">
                    <DropdownSection className="dropdown-container1">
                        <DropdownTitle>Início</DropdownTitle>
                        <Select
                            isSearchable
                            menuPlacement="auto"
                            value={optionStart}
                            onChange={onChangeStart}
                            selectStyles={{
                                width: 160
                            }}
                            menuPortalTarget={node}
                            options={OPTIONS_HORARIOS}
                        />
                    </DropdownSection>

                    <DropdownSection className="dropdown-container2">
                        <DropdownTitle>Término</DropdownTitle>
                        <Select
                            isSearchable
                            menuPlacement="auto"
                            value={optionEnd}
                            onChange={onChangeEnd}
                            defaultValue={OPTIONS_HORARIOS[0]}
                            selectStyles={{
                                width: 160,
                                zIndex: 9999
                            }}
                            options={OPTIONS_HORARIOS}
                        />
                    </DropdownSection>
                </SelectContent>
                <Footer className="buttons">
                    <Button
                        onClick={closeAddTimeModal}
                        style={{
                            backgroundColor: `${Colors.grey_light}`,
                            color: `${Colors.dark}`,
                            border: `1px solid ${Colors.regular}`,
                            marginRight: 15,
                            minHeight: 45,
                            minWidth: 135
                        }}
                        title="Cancelar"
                    />
                    <Button
                        onClick={() => {
                            addTimeToday();
                        }}
                        style={{
                            minHeight: 45,
                            minWidth: 135,
                            fontWeight: 'bold'
                        }}
                        title="Adicionar"
                    />
                </Footer>
            </Container>
        </Modal>
    );
});
